import React from 'react'
import { Box } from '@mui/material'

interface PoweredByProps {
    src: string
    alt: string
    /** Rendered height in px; the width follows the logo's own aspect ratio. */
    height: number
    align?: 'start' | 'center'
}

const PoweredBy: React.FC<PoweredByProps> = ({ src, alt, height, align = 'start' }) => (
    <Box sx={{ display: 'flex', justifyContent: align === 'center' ? 'center' : 'flex-start' }}>
        {/* The PNG has an opaque white background; multiply drops it on tinted surfaces. */}
        <Box
            component="img"
            src={src}
            alt={alt}
            loading="lazy"
            sx={{ display: 'block', height, width: 'auto', mixBlendMode: 'multiply' }}
        />
    </Box>
)

export { PoweredBy }
export type { PoweredByProps }
export default PoweredBy
